const SORT_ORDERS = {
    asc: 'asc',
    desc: 'desc',
    undefined: 'undefined',
}

Object.freeze(SORT_ORDERS)

export default SORT_ORDERS
